<template>
  <section>
    <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" color="#3CB371" dark app fixed flat>
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <a :href="`${webUrl}`" target="_blank">
        <img src="@/assets/logo.png" style="width: 100px; height: 70px;" alt="">
        </a>
      </v-toolbar-title>
      <v-spacer class="hidden-sm-and-down"></v-spacer>
      <div class="hidden-sm-and-down">
        <v-menu style="display:inline;">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small flat
              v-bind="attrs"
              v-on="on"
            >
              Support
            </v-btn>
          </template>
          <v-list>
            <v-list-tile :href="`${webUrl}/faqs`">
              <v-btn target="_blank" :href="`${webUrl}/faqs`" small flat>FAQs</v-btn>
            </v-list-tile>
            <v-list-tile :to="'/tickets'">
              <v-btn :to="'/tickets'" small flat>Ticket</v-btn>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn :to="'/sonko/landing'" small flat> Experts in My Location</v-btn>
        <v-btn :to="'/sonko/jobs/active'" small flat>My Jobs</v-btn>
        <v-btn icon>
          <v-icon>notifications</v-icon>
        </v-btn>
      </div>  
      <div class="text-xs-center hidden-sm-and-down">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <!-- Welcome {{user.firstName}} -->
            <v-btn icon large v-on="on">
              <v-icon>person_outline</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile
              v-for="(item, index) in items"
              :key="index"
              @click="menuAction(item.actionType)"
            >
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>
    <v-navigation-drawer
        v-model="drawer"
        width = "250"
        id = "drawer"
        clipped
        temporary
        app
        hide-overlay
        disable-resize-watcher
        class="hidden-md-and-up"
      >
      <v-btn flat class="pl-2">Welcome {{user.firstName}}</v-btn>
      <v-btn :to="'/sonko/landing'" small flat> Experts in My Location</v-btn>
      <v-btn :to="'/sonko/jobs/active'" small flat>My Jobs</v-btn>
      <v-menu >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="display:block;"
              small flat
              v-bind="attrs"
              v-on="on"
            >
              Support
            </v-btn>
          </template>
          <v-list>
            <v-list-tile :href="`${webUrl}/faqs`">
              <v-btn target="_blank" :href="`${webUrl}/faqs`" small flat>FAQs</v-btn>
            </v-list-tile>
            <v-list-tile :to="'/tickets'">
              <v-btn :to="'/tickets'" small flat>Ticket</v-btn>
            </v-list-tile>
          </v-list>
        </v-menu>
      <v-btn flat>
        <v-icon>notifications</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile
          v-for="(item, index) in items"
          :key="index"
          @click="menuAction(item.actionType)"
        >
          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile>
      </v-list>   
       
  </v-navigation-drawer>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["appName"]),
    ...mapGetters(['user']),
    ...mapGetters(['webUrl'])
  },
  data: () => ({
    dialog: false,
    drawer: null,
    items: [
      { text: "My Account", actionType: "account" },
      { text: "Log Out", actionType: "logout" }
    ],
    drawer: false,
  }),
  methods: {
    menuAction(data) {
      if (data == "logout") {
        const accountType = this.user.accountType;
        this.$store.commit('removeUser');
        localStorage.removeItem('token');
        this.$router.push(`/login/${accountType}/normal`);
      } else if (data == "account") {
        this.$router.push("/sonko/profile");
      }
    }
  }
};
</script>
